module.exports = __webpack_public_path__ + "static/intertec_product_1-62a2606286e21ef20f50c1a72417eb53.png";